import { useEffect, useState, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import "@/App.css";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PublicScan from "@/pages/PublicScan";
import { api, setAuthToken } from "@/lib/api";

export const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

function AuthProvider({ children }) {
  const [state, setState] = useState({ status: "loading", user: null });

  useEffect(() => {
    const token = localStorage.getItem("jscan_token");
    if (!token) {
      setState({ status: "unauth", user: null });
      return;
    }
    setAuthToken(token);
    api
      .get("/auth/me")
      .then((res) => setState({ status: "auth", user: res.data }))
      .catch(() => {
        localStorage.removeItem("jscan_token");
        setAuthToken(null);
        setState({ status: "unauth", user: null });
      });
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("jscan_token", data.token);
    setAuthToken(data.token);
    setState({ status: "auth", user: { username: data.username } });
  };

  const logout = () => {
    localStorage.removeItem("jscan_token");
    setAuthToken(null);
    setState({ status: "unauth", user: null });
  };

  return (
    <AuthCtx.Provider value={{ ...state, login, logout }}>{children}</AuthCtx.Provider>
  );
}

function Protected({ children }) {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0B0F17]">
        <div className="text-sm text-slate-500">Memuat...</div>
      </div>
    );
  }
  if (status !== "auth") return <Navigate to="/login" replace />;
  return children;
}

function LoginGate() {
  const { status } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (status === "auth") navigate("/", { replace: true });
  }, [status, navigate]);
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/q/:code" element={<PublicScan />} />
          <Route
            path="/"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
